import React from "react";
import { translate } from "react-admin";
import { compose } from "recompose";
import Card from "@material-ui/core/Card";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import FormControl from "@material-ui/core/FormControl";
import { MuiThemeProvider } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { lightTheme } from "../../layout/MyLayout";

const HelpContent = ({ content, translate }) => {
  const cardStyle = {
    marginTop: "2em",
  };

  const formControlStyle = {
    minWidth: 250,
    marginRight: "5em",
    marginLeft: "1em",
    display: "flex",
    flexWrap: "wrap",
  };

  const buttonStyle = {
    textAlign: "left",
    maxWidth: "12.5em",
  };

  return (
    <MuiThemeProvider theme={lightTheme}>
      <Card style={cardStyle}>
        <List>
          <ListItem>
            <ListItemText primary={translate(content.title)} />
          </ListItem>
          <ListItem>
            <FormControl style={formControlStyle}>
              <Button
                color="primary"
                href={content.url}
                target={content.target ?? ""}
                style={buttonStyle}
              >
                {translate(content.label)}
              </Button>
            </FormControl>
          </ListItem>
        </List>
      </Card>
    </MuiThemeProvider>
  );
};

const enhance = compose(translate);
export default enhance(HelpContent);
